var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.636,
    height: 48.362,
    viewBox: "0 0 42.636 48.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(-15.25 -15.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14614",
    "data-name": "Path 14614",
    d: "M53.022,62.862H20.114A4.429,4.429,0,0,1,16,58.176V20.686A4.429,4.429,0,0,1,20.114,16H53.022a4.429,4.429,0,0,1,4.114,4.686v37.49A4.429,4.429,0,0,1,53.022,62.862ZM20.114,19.124a1.48,1.48,0,0,0-1.371,1.562v37.49a1.48,1.48,0,0,0,1.371,1.562H53.022a1.48,1.48,0,0,0,1.371-1.562V20.686a1.48,1.48,0,0,0-1.371-1.562Z",
    fill: "#18cc96",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14615",
    "data-name": "Path 14615",
    d: "M81.457,131.124h-.086a1.575,1.575,0,0,1,0-3.124h.086a1.575,1.575,0,0,1,0,3.124Zm0,21.869h-.086a1.575,1.575,0,0,1,0-3.124h.086a1.575,1.575,0,0,1,0,3.124Zm0-10.935h-.086a1.575,1.575,0,0,1,0-3.124h.086a1.575,1.575,0,0,1,0,3.124Z",
    transform: "translate(-58.515 -101.065)",
    fill: "#18cc96",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9568",
    "data-name": "Group 9568",
    transform: "translate(26.97 26.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14616",
    "data-name": "Path 14616",
    d: "M167.31,131.124H145.371a1.575,1.575,0,0,1,0-3.124H167.31a1.575,1.575,0,0,1,0,3.124Zm0,21.869H145.371a1.575,1.575,0,0,1,0-3.124H167.31a1.575,1.575,0,0,1,0,3.124Zm0-10.935H145.371a1.575,1.575,0,0,1,0-3.124H167.31a1.575,1.575,0,0,1,0,3.124Z",
    transform: "translate(-144 -128)",
    fill: "#18cc96",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.ea207c493f74d6a5138dd5eedd6b79f4.svg";
export { ForwardRef as ReactComponent };